import { FC } from 'react'
import { Create, SimpleForm } from 'react-admin'
import { ActionsToolbar, HeaderTitle } from '../../components'
import NotificationConfigurationForm from './NotificationConfigurationForm'

const NotificationConfigurationsCreate: FC = () => (
  <Create
    actions={<ActionsToolbar i18n="resources.notificationConfigurations.create" />}
    title={<HeaderTitle i18n="resources.notificationConfigurations.create" />}
  >
    {/* eslint-disable-next-line camelcase */}
    <SimpleForm defaultValues={{ action_type: 'create_case', action_config: {} }}>
      <NotificationConfigurationForm />
    </SimpleForm>
  </Create>
)

export default NotificationConfigurationsCreate
